export function defaultValidator(pattern, value) {
  return pattern.test(value);
}



// WEBPACK FOOTER //
// ./src/utils/validations/defaultValidator.js